<div class="modal-body">
  <div class="erro-container">
    <div class="icone-erro">
      <i class="fa fa-exclamation-triangle text-danger"></i>
    </div>

    <h4 class="titulo-erro">{{ titulo }}</h4>

    <div class="detalhes-erro">
      <div class="info-item">
        <strong>Sistema:</strong> {{ sistema }}
      </div>
      
      <div class="info-item">
        <strong>Pedido:</strong> {{ pedido }}
      </div>
      
      <div class="info-item">
        <strong>Data/Hora:</strong> {{ dataHora }}
      </div>
      
      <div class="erro-mensagem">
        <strong>Erro:</strong>
        <div class="erro-texto">{{ erro }}</div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn"
    [ngClass]="erroCopiado ? 'btn-success' : 'btn-outline-secondary'"
    (click)="copiarErro()"
    [disabled]="erroCopiado">
    <i class="fa mr-1" [ngClass]="erroCopiado ? 'fa-check' : 'fa-copy'"></i>
    {{ erroCopiado ? 'Copiado!' : 'Copiar Erro' }}
  </button>

  <button
    type="button"
    class="btn btn-secondary"
    (click)="fechar()">
    Fechar
  </button>
</div>
